import {
  GET_ASSIGNED_REVIEWS_LIST,
  SET_SELECTED_REVIEW_TAB,
  SET_EXTENDED_REVIEW,
  ReviewActionType,
  ReviewState,
  ExtendedReview,
} from '../types';

const INITIAL_STATE: ReviewState = {
  assignedReviewsList: undefined,
  selectedReviewTab: undefined,
};

function setExtendedReview(state: ReviewState, payload?: ExtendedReview) {
  if (payload === undefined) {
    const { extendedReview, ...rest } = state;
    return {
      ...rest,
    };
  }
  return {
    ...state,
    extendedReview: payload,
  };
}

export default (state = INITIAL_STATE, action: ReviewActionType): ReviewState => {
  switch (action.type) {
    case GET_ASSIGNED_REVIEWS_LIST:
      return {
        ...state,
        assignedReviewsList: action.payload,
      };
    case SET_SELECTED_REVIEW_TAB:
      return {
        ...state,
        selectedReviewTab: action.payload,
      };
    case SET_EXTENDED_REVIEW:
      return setExtendedReview(state, action.payload);
    default:
      return state;
  }
};
